import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BarChart3, TrendingUp } from "lucide-react";
import { useChartData } from "../hooks/useChartData";
import { useUsageData } from "../hooks/useUsageData";
import { USAGE_VIEW_TYPES } from "@/constants/usage";
import { formatUsageValue } from "@/utils/formatters";
export const SummaryStatsCards = ({ contractId, filters })=>{
    const { data: usageData } = useUsageData(filters, contractId);
    const { totalUsage, avgUsage, unit } = useChartData(usageData, filters);
    const viewTypeLabel = filters.viewType === USAGE_VIEW_TYPES.HOURLY ? "Daily Usage" : "Total Usage";
    const averageLabel = filters.viewType === USAGE_VIEW_TYPES.HOURLY ? "Average/Hour" : "Average/Day";
    return /*#__PURE__*/ _jsxs("div", {
        className: "grid grid-cols-1 gap-5 sm:grid-cols-2",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "bg-white overflow-hidden shadow rounded-lg",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "p-5",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex-shrink-0",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "p-3 rounded-md bg-blue-50",
                                    children: /*#__PURE__*/ _jsx(BarChart3, {
                                        className: "h-6 w-6 text-blue-600"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "ml-5 w-0 flex-1",
                                children: /*#__PURE__*/ _jsxs("dl", {
                                    children: [
                                        /*#__PURE__*/ _jsx("dt", {
                                            className: "text-sm font-medium text-gray-500 truncate",
                                            children: viewTypeLabel
                                        }),
                                        /*#__PURE__*/ _jsx("dd", {
                                            className: "text-lg font-medium text-gray-900",
                                            children: formatUsageValue(totalUsage, unit)
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "bg-white overflow-hidden shadow rounded-lg",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "p-5",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex-shrink-0",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "p-3 rounded-md bg-green-50",
                                    children: /*#__PURE__*/ _jsx(TrendingUp, {
                                        className: "h-6 w-6 text-green-600"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "ml-5 w-0 flex-1",
                                children: /*#__PURE__*/ _jsxs("dl", {
                                    children: [
                                        /*#__PURE__*/ _jsx("dt", {
                                            className: "text-sm font-medium text-gray-500 truncate",
                                            children: averageLabel
                                        }),
                                        /*#__PURE__*/ _jsx("dd", {
                                            className: "text-lg font-medium text-gray-900",
                                            children: formatUsageValue(avgUsage, unit)
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
